<footer>
  <div class="dat-label">
    <wb-text size="m" static strong>{{ 'DAT_LABEL' | translate }}</wb-text>
    <wb-button mbRouterLink="/presscontacts" variant="secondary" theme="dark">
      {{ 'PRESS_CONTACTS' | translate }}
    </wb-button>
  </div>

  <div class="social-link-row">
    <ul>
      <li>
        <a href="https://www.instagram.com/mercedesbenz" aria-label="Instagram" target="_blank">
          <wb-icon slot="icon" name="bds/instagram/24"></wb-icon>
        </a>
      </li>
      <li>
        <a href="https://facebook.com/MercedesBenz" aria-label="Facebook" target="_blank">
          <wb-icon slot="icon" name="bds/facebook/24"></wb-icon>
        </a>
      </li>
      <li>
        <a href="https://x.com/mercedesbenz" aria-label="X" target="_blank">
          <wb-icon slot="icon" name="bds/x/24"></wb-icon>
        </a>
      </li>
      <li>
        <a href="https://linkedin.com/company/mercedes-benz_ag" aria-label="LinkedIn" target="_blank">
          <wb-icon slot="icon" name="bds/linkedin/24"></wb-icon>
        </a>
      </li>
      <li>
        <a href="https://youtube.com/user/MercedesBenzTV" aria-label="YouTube" target="_blank">
          <wb-icon slot="icon" name="bds/youtube/24"></wb-icon>
        </a>
      </li>
      <li>
        <a href="https://tiktok.com/@mercedesbenz" aria-label="TikTok" target="_blank">
          <wb-icon src="assets/icons/mb-tiktok.svg"></wb-icon>
        </a>
      </li>
    </ul>
  </div>

  <div class="more-information">
    <wb-heading size="l">{{ 'MORE_INFORMATION' | translate }}</wb-heading>

    <nav>
      <section>
        <wb-text size="l" static strong>{{ 'FOOTER.COMPANY.HEADLINE' | translate }}</wb-text>
        <wb-link href="{{ 'FOOTER.COMPANY.OVERVIEW.LINK' | translate }}" variant="small" theme="dark" target="_blank">
          {{ 'FOOTER.COMPANY.OVERVIEW.LABEL' | translate }}
        </wb-link>
        <wb-link href="{{ 'FOOTER.COMPANY.CAREERS.LINK' | translate }}" variant="small" theme="dark" target="_blank">
          {{ 'FOOTER.COMPANY.CAREERS.LABEL' | translate }}
        </wb-link>
        <wb-link href="{{ 'FOOTER.COMPANY.INVESTORS.LINK' | translate }}" variant="small" theme="dark" target="_blank">
          {{ 'FOOTER.COMPANY.INVESTORS.LABEL' | translate }}
        </wb-link>
        <wb-link href="{{ 'FOOTER.COMPANY.LOCATIONS.LINK' | translate }}" variant="small" theme="dark" target="_blank">
          {{ 'FOOTER.COMPANY.LOCATIONS.LABEL' | translate }}
        </wb-link>
      </section>

      <section>
        <wb-text size="l" static strong>{{ 'FOOTER.KNOWLEDGE.HEADLINE' | translate }}</wb-text>
        <wb-link
          href="{{ 'FOOTER.KNOWLEDGE.CORPORATE_GOVERNANCE.LINK' | translate }}"
          variant="small"
          theme="dark"
          target="_blank"
        >
          {{ 'FOOTER.KNOWLEDGE.CORPORATE_GOVERNANCE.LABEL' | translate }}
        </wb-link>
        <wb-link
          href="{{ 'FOOTER.KNOWLEDGE.COMPLIANCE.LINK' | translate }}"
          variant="small"
          theme="dark"
          target="_blank"
        >
          {{ 'FOOTER.KNOWLEDGE.COMPLIANCE.LABEL' | translate }}
        </wb-link>
        <wb-link
          href="{{ 'FOOTER.KNOWLEDGE.KEY_FIGURES.LINK' | translate }}"
          variant="small"
          theme="dark"
          target="_blank"
        >
          {{ 'FOOTER.KNOWLEDGE.KEY_FIGURES.LABEL' | translate }}
        </wb-link>
        <wb-link
          href="{{ 'FOOTER.KNOWLEDGE.SUSTAINABILITY.LINK' | translate }}"
          variant="small"
          theme="dark"
          target="_blank"
        >
          {{ 'FOOTER.KNOWLEDGE.SUSTAINABILITY.LABEL' | translate }}
        </wb-link>
        <wb-link
          href="{{ 'FOOTER.KNOWLEDGE.DIVERSITY.LINK' | translate }}"
          variant="small"
          theme="dark"
          target="_blank"
        >
          {{ 'FOOTER.KNOWLEDGE.DIVERSITY.LABEL' | translate }}
        </wb-link>
        <wb-link
          href="{{ 'FOOTER.KNOWLEDGE.CORPORATE_STRATEGY.LINK' | translate }}"
          variant="small"
          theme="dark"
          target="_blank"
        >
          {{ 'FOOTER.KNOWLEDGE.CORPORATE_STRATEGY.LABEL' | translate }}
        </wb-link>
        <wb-link
          href="{{ 'FOOTER.KNOWLEDGE.TRADITION.LINK' | translate }}"
          variant="small"
          theme="dark"
          target="_blank"
        >
          {{ 'FOOTER.KNOWLEDGE.TRADITION.LABEL' | translate }}
        </wb-link>
      </section>

      <section>
        <wb-text size="l" static strong>{{ 'FOOTER.SERVICES.HEADLINE' | translate }}</wb-text>
        <wb-link
          mbRouterLink="/presscontacts"
          [mbRouterLinkExtras]="{ state: { scrollRestoration: 'top' } }"
          variant="small"
          theme="dark"
        >
          {{ 'PRESS_CONTACTS' | translate }}
        </wb-link>
        <wb-link
          mbRouterLink="/newsletter/subscribe"
          [mbRouterLinkExtras]="{ state: { scrollRestoration: 'top' } }"
          variant="small"
          theme="dark"
        >
          {{ 'NEWSLETTER' | translate }}
        </wb-link>
        <wb-link
          href="{{ 'FOOTER.SERVICES.CORPORATE_ARCHIVE.LINK' | translate }}"
          variant="small"
          theme="dark"
          target="_blank"
        >
          {{ 'FOOTER.SERVICES.CORPORATE_ARCHIVE.LABEL' | translate }}
        </wb-link>
        <wb-link
          mbRouterLink="/national-media-sites"
          [mbRouterLinkExtras]="{ state: { scrollRestoration: 'top' } }"
          variant="small"
          theme="dark"
        >
          {{ 'NATIONAL_MEDIA_SITES' | translate }}
        </wb-link>
        <wb-link
          href="{{ 'FOOTER.SERVICES.MB_MAGAZINE.LINK' | translate }}"
          variant="small"
          theme="dark"
          target="_blank"
        >
          {{ 'FOOTER.SERVICES.MB_MAGAZINE.LABEL' | translate }}
        </wb-link>
        <wb-link
          href="{{ 'FOOTER.SERVICES.MB_CLASSIC_MAGAZINE.LINK' | translate }}"
          variant="small"
          theme="dark"
          target="_blank"
        >
          {{ 'FOOTER.SERVICES.MB_CLASSIC_MAGAZINE.LABEL' | translate }}
        </wb-link>
      </section>
      <section>
        <wb-text size="l" static strong>{{ 'FOOTER.PURCHASE.HEADLINE' | translate }}</wb-text>
        <wb-link href="{{ 'FOOTER.PURCHASE.VEHICLES.LINK' | translate }}" variant="small" theme="dark" target="_blank">
          {{ 'FOOTER.PURCHASE.VEHICLES.LABEL' | translate }}
        </wb-link>
        <wb-link
          href="{{ 'FOOTER.PURCHASE.ACCESSORIES.LINK' | translate }}"
          variant="small"
          theme="dark"
          target="_blank"
        >
          {{ 'FOOTER.PURCHASE.ACCESSORIES.LABEL' | translate }}
        </wb-link>
        <wb-link
          href="{{ 'FOOTER.PURCHASE.DIGITAL_EXTRAS.LINK' | translate }}"
          variant="small"
          theme="dark"
          target="_blank"
        >
          {{ 'FOOTER.PURCHASE.DIGITAL_EXTRAS.LABEL' | translate }}
        </wb-link>
        <wb-link
          href="{{ 'FOOTER.PURCHASE.CLASSIC_CARS.LINK' | translate }}"
          variant="small"
          theme="dark"
          target="_blank"
        >
          {{ 'FOOTER.PURCHASE.CLASSIC_CARS.LABEL' | translate }}
        </wb-link>
      </section>
    </nav>
  </div>

  <div class="bottom-navigation">
    <wb-header-language-menu aria-label="{{ 'LANGUAGE_MENU' | translate }}">
      @for (lang of languages; track lang.isoLang) {
        <wb-header-language-menu-item
          (click)="changeLanguage(lang.isoLang)"
          [active]="currentLanguage === lang.isoLang"
        >
          {{ lang.label }}
        </wb-header-language-menu-item>
      }
    </wb-header-language-menu>

    <ul>
      <li>
        <wb-link
          variant="small"
          theme="dark"
          mbRouterLink="/legal/provider"
          [mbRouterLinkExtras]="{ state: { scrollRestoration: 'top' } }"
        >
          {{ 'LEGAL_PRIVACY_PROVIDER_SHORT' | translate }}
        </wb-link>
      </li>
      <li>
        <wb-link
          variant="small"
          theme="dark"
          mbRouterLink="/legal/legal-notice"
          [mbRouterLinkExtras]="{ state: { scrollRestoration: 'top' } }"
        >
          {{ 'LEGAL_LEGAL_NOTICE' | translate }}
        </wb-link>
      </li>
      <li>
        <wb-link
          variant="small"
          theme="dark"
          mbRouterLink="/legal/settings"
          [mbRouterLinkExtras]="{ state: { scrollRestoration: 'top' } }"
        >
          {{ 'LEGAL_CONSENT_SETTINGS' | translate }}
        </wb-link>
      </li>
      <li>
        <wb-link
          variant="small"
          theme="dark"
          mbRouterLink="/legal/privacy-statement"
          [mbRouterLinkExtras]="{ state: { scrollRestoration: 'top' } }"
        >
          {{ 'LEGAL_PRIVACY' | translate }}
        </wb-link>
      </li>
      @if (showCCPALink) {
        <li>
          <wb-link
            variant="small"
            theme="dark"
            mbRouterLink="/legal/privacy-statement"
            [mbRouterLinkExtras]="{ state: { scrollRestoration: 'top' }, fragment: 'CCPA' }"
          >
            {{ 'Do not sell or share my personal information' }}
          </wb-link>
        </li>
      }
      <li>
        <wb-link
          variant="small"
          theme="dark"
          mbRouterLink="/legal/terms-of-use"
          [mbRouterLinkExtras]="{ state: { scrollRestoration: 'top' } }"
          >{{ 'LEGAL_TERMS_OF_USE' | translate }}
        </wb-link>
      </li>
      <li>
        @if (isBrowser) {
          <wb-link variant="small" theme="dark" class="copy-s" [attr.href]="supportUrl" target="_blank" rel="help">
            {{ 'FOOTER.SUPPORT.BUTTON_LABEL' | translate }}
          </wb-link>
        } @else {
          <a class="copy-s" [attr.href]="supportUrl" target="_blank" rel="help">
            {{ 'FOOTER.SUPPORT.BUTTON_LABEL' | translate }}
          </a>
        }
      </li>
      <li>
        <wb-link
          mbRouterLink="/license-notice"
          [mbRouterLinkExtras]="{ state: { scrollRestoration: 'top' } }"
          variant="small"
          theme="dark"
        >
          {{ 'THIRD_PARTY_LICENSES' | translate }}
        </wb-link>
      </li>
      <li>
        <wb-link
          mbRouterLink="/legal/accessibility"
          [mbRouterLinkExtras]="{ state: { scrollRestoration: 'top' } }"
          variant="small"
          theme="dark"
        >
          {{ 'LEGAL_ACCESSIBILITY' | translate }}
        </wb-link>
      </li>
    </ul>
  </div>
</footer>
